import i18n from 'i18next';
import XHR from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import setting from '../../config/settings';

i18n
    .use(XHR)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: 'en',
        fallbackLng: 'en',
        ns: ['translation'],
        defaultNS: 'translation',
        debug: false,
        backend: {
            loadPath: `${setting.BackendUrl}/metadata/uiLanguages/en-US`,
            crossDomain: true,
            withCredentials: false,
            parse: (data) => {
                const pastedData = JSON.parse(data);

                return pastedData.result.data;
            },
        },
        interpolation: {
            escapeValue: false,
        },
        react: {
            wait: true,
            useSuspense: false,
        },
        // allow include `:`, `.`
        nsSeparator: false,
        keySeparator: false,
    });

export default i18n;
